import { DBO_TM } from '@op/utils/format';
import { TComponentConfig, IDateCommonSelectType } from '../types';
import { getDateDefaultValue, getMultipleSelectDefaultValue } from '../utils';
import MultiDateSelect, { TMultiDateSelect } from '../widgets/MultiDateSelect';
import { defaultRangePickerValue } from '@op/components/FilterCommon/constants/date';
import RadioAllMultipleSelect, {
  RadioAllMultipleSelectType,
} from '../components/RadioAllMultipleSelect';
import ChannelLabel from '@op/components/ChannelLabel';
import React from 'react';

const defaultValue = defaultRangePickerValue();

export const OpinionMultiDateRange: TComponentConfig<TMultiDateSelect> = {
  Component: MultiDateSelect,
  props: {
    valueKeys: {
      start_time: 'start_time',
      end_time: 'end_time',
      date_type: 'date_type',
    },
    typeList: ['date', 'week', 'month'],
    enableMaximumDuration: true,
    defaultValue: {
      ...defaultValue,
      date: [DBO_TM.utc().subtract(13, 'day'), DBO_TM.utc()],
    } as any,
  },
  defaultValue: (filterValue: any, props: IDateCommonSelectType) => {
    return getDateDefaultValue(filterValue, props);
  },
};

export const OpinionChannel: TComponentConfig<RadioAllMultipleSelectType> = {
  Component: RadioAllMultipleSelect,
  defaultValue: (filterValue: any, props: RadioAllMultipleSelectType) => {
    const { valueKeys: key, options } = props;
    return getMultipleSelectDefaultValue(filterValue, key, options, []);
  },
  backValue: (filterValue: any, props: RadioAllMultipleSelectType) => {
    const { valueKeys: key, options } = props;
    const selectedValues = filterValue[key] || [];
    const allOptionValues = options.map((opt: any) => opt.value);

    // 判断是否全选：选中的值和options完全一致
    const isAllSelected = selectedValues.length === allOptionValues.length &&
      allOptionValues.every((val: any) => selectedValues.includes(val));

    const result: any = { [key]: filterValue[key] };
    if (isAllSelected) {
      result.need_others = true;
    }

    return result;
  },
  requestKey: "materials_config_channels",
  props: {
    title: 'Channel',
    titleCn: '渠道',
    valueKeys: 'dimension_values',
    itemRender: (item: any) => (
      <ChannelLabel
        iconStyle={{ width: 18, height: 18 }}
        channel_name={item?.value as 'tiktok'}
        isMarketing
      />
    ),
    matchButtonWidth: true,
    allText: "Top 10",
    allTextCn: "前10", 
    leftText: "Channel",
    options: [],
  },
};
